import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";

// Components
import CustomParagraph from "./CustomParagraph";
import CustomButton from "./CustomButton";
import CustomModal from "./CustomModal";
import ContactSalesTeam from "../pages/landing/components/ContactSalesTeam";

// Assets
import BlueLogo from "../assets/images/b-logo.svg";
import { CustomModalWithoutButton } from ".";
const Header = () => {
  const [modalOpen, setModalOpen] = useState(false);
  const openContactTeamModal = () => {
    setModalOpen(true);
  };

  const closeModal = () => {
    setModalOpen(false);
  }

  const [isSticky, setIsSticky] = useState(false);

  const handleScroll = () => {
    if (window.pageYOffset > 0) {
      setIsSticky(true);
    } else {
      setIsSticky(false);
    }
  };

  useEffect(() => {
    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  return (
    <>
      <header className={`header ${isSticky ? 'is-sticky' : ''}`}>
        <div className="container">
          <div className="header-content">
            <Link to="/" title="logo" className="header-logo">
              <img src={BlueLogo} alt="" />
              <CustomParagraph
                text="ZoomLogi"
                fontSize={"16px"}
                fontWeight={"600"}
                lineHeight={"28px"}
                marginBottom={0}
              />
            </Link>

            <div className="header-btn">
              <Link to="/login" className="btn btn-primary">
                Login
              </Link>
              <CustomButton
                text="Contact sales"
                fontSize="14px"
                fontWeight="700"
                lineHeight="16px"
                bgColor="white"
                color="black"
                height="36px"
                width="118px"
                boxShadow="none"
                onClick={() => openContactTeamModal()}
              />
            </div>
          </div>
        </div>
      </header>
      <CustomModalWithoutButton
        modalTitle="Contact our sales team"
        modalOpen={modalOpen}
        setModalOpen={setModalOpen}
        modalSize={500}
      >
        <ContactSalesTeam closeModal={closeModal} />
      </CustomModalWithoutButton>
    </>
  );
};

export default Header;
